/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Zwelibanzi Ntongana ",
  logo_name: "Zwelibanzi Ntongana",
  nickname: "jones",
  full_name: "Zwelibanzi Ntongana",
  subTitle:
    "A Full Stack  || MERN Stack  || MEAN Stack || Django Stack Developer, Open Source Enthusiast 🔥. Always learning 💪. A Java, Python & Javascript lover.❤️ ",
  resumeLink:
    "https://drive.google.com/file/d/1l5CeRe2dQ8bPRPlRqUo6nBhIXXH0fTaA/view?usp=sharing",
  mail: "mailto:jonesntongana345@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/jones345",
  linkedin: "https://www.linkedin.com/in/zwelibanzi-ntongana-b46733145/",
  gmail: "jonesntongana345@gmail.com",
  gitlab: "",
  facebook: "",
  twitter: "",
  instagram: "",
};

const skills = {
  data: [
    {
      title: "My Stack Skills",
      fileName: "FullStackImg",
      skills: [
        "⚡  I Build responsive web applications front end using ReactJS and Angular ",
        "⚡  I Build highly interactive RESTful APIs services using ExpressJS and MongoDB,",
        "⚡  I Build highly backend RESTful APIs using Java, Spring boot and PostgreSQL",
        "⚡  I Develop mobile applications using Flutter, Android Studio,React Native and ionic",
        "⚡ Creating application backend using Node, Express, Flask Django & Spring Boot",
        "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean",
        "⚡  I Build Front end CSS Framework using Bootstrap, Tailwindcss, MaterializeCSS",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        {
          skillName: "Auth0",
          fontAwesomeClassname: "simple-icons:auth0",
          style: {
            color: "#029FCE",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Ubuntu",
          fontAwesomeClassname: "simple-icons:ubuntu",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "simple-icons:gitlab",
          style: {
            color: "#FCA121",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#FFB13B",
          },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326E90",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Spring Security",
          fontAwesomeClassname: "simple-icons:springsecurity",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Selenium",
          fontAwesomeClassname: "simple-icons:selenium",
          style: {
            color: "#24FF00",
          },
        },
        {
          skillName: "Anaconda",
          fontAwesomeClassname: "simple-icons:anaconda",
          style: {
            color: "#44A833",
          },
        },
        {
          skillName: "Passport JS",
          fontAwesomeClassname: "simple-icons:passport",
          style: {
            color: "#34E27A",
          },
        },
        {
          skillName: "Elasticsearch",
          fontAwesomeClassname: "simple-icons:elasticsearch",
          style: {
            color: "#FFD200",
          },
        },
        {
          skillName: "SQLite",
          fontAwesomeClassname: "simple-icons:sqlite",
          style: {
            color: "#2E5E82",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Atlassian",
          fontAwesomeClassname: "simple-icons:atlassian",
          style: {
            color: "#0052CC",
          },
        },
        {
          skillName: "Bitbucket",
          fontAwesomeClassname: "simple-icons:bitbucket",
          style: {
            color: "#0052CC",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "simple-icons:jira",
          style: {
            color: "#0052CC",
          },
        },
        {
          skillName: "Trello",
          fontAwesomeClassname: "simple-icons:trello",
          style: {
            color: "#0052CC",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style: {
            color: "#7F52FF",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#7952B3",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "PurgeCSS",
          fontAwesomeClassname: "simple-icons:purgecss",
          style: {
            color: "#14161A",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#430098",
          },
        },
        {
          skillName: "Visual Studio",
          fontAwesomeClassname: "simple-icons:visualstudio",
          style: {
            color: "#5C2D91",
          },
        },
        {
          skillName: "JetBrains",
          fontAwesomeClassname: "simple-icons:jetbrains",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Expo",
          fontAwesomeClassname: "simple-icons:expo",
          style: {
            color: "#000020",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#C41E25",
          },
        },

        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "simple-icons:tailwindcss",
          style: {
            color: "#06B6D4",
          },
        },
        {
          skillName: "Slack",
          fontAwesomeClassname: "simple-icons:slack",
          style: {
            color: "#4A154B",
          },
        },
        {
          skillName: "WebRTC",
          fontAwesomeClassname: "simple-icons:webrtc",
          style: {
            color: "#333333",
          },
        },
        {
          skillName: "Socket.io",
          fontAwesomeClassname: "simple-icons:socketio",
          style: {
            color: "#010101",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience with Heroku",
        "⚡ Experience with Netlify",
        "⚡ Experience with Firebase",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Sunderland",
      subtitle: "Bachelor of Computer Systems Engineering Top Up",
      logo_path: "sundarland.jpg",
      alt_name: "University of Sunderland",
      duration: "2019 - 2020",
      descriptions: [
        "⚡ Research: contextualised  a research problem, collected data, analysed and presented data, and evaluated  methodology adopted.",
        "⚡ Product Development: developed a product using a product development methodology.",
        "⚡ Advanced Cyber Security:analysed the range of tradeoffs in balancing the security properties of confidentiality, integrity, availability",
        "⚡ Android Mobile Development: developed an Android application using Java, Android Studio, and Firebase/SQLite.",
        "⚡ Advanced Data Technologies:enhanced data models, query optimisation, clustering, scalability, security, forensic investigation, data warehousing, data analysis",
        "⚡ Artificial Intelligence: developed a machine learning algorithm using Python, TensorFlow, and Scikit-Learn.",
      ],
      website_link:
        "https://www.sunderland.ac.uk/study/computing/undergraduate-computer-systems-engineering-top-up/",
    },
    {
      title: "Botswana accountancy college",
      subtitle: "Bachelor of Computer Systems Engineering",
      logo_path: "bac.png",
      alt_name: "Botswana accountancy college",
      duration: "2016 - 2019",
      descriptions: [
        "⚡ Computer Related Mathematics and Statistics",
        "⚡ Web and Multimedia Development",
        "⚡ Object Oriented Analysis & with Java ",
        "⚡ Mobile Application Development",
        "⚡ Database Design & Development",
        "⚡ Discrete Mathematics",
        "⚡ Research & Innovation",
        "⚡ Intelligent Systems",
      ],
      website_link:
        "https://www.bac.ac.bw/bsc-hons-computer-systems-engineering",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Android studio Developer",
      subtitle: " Google Android studio Developer",
      logo_path: "Android_Studio_Icon.png",
      alt_name: "Google Android studio Developer",
      color_code: "#47A048",
    },
    {
      title: "Flutter and Dart for android and IOS development",
      subtitle: "Flutter and Dart for android and IOS development",
      logo_path: "flutter.png",
      alt_name: "hackathon",
      color_code: "#2AAFED",
    },
    {
      title: "Agile with Atlassian Jira",
      subtitle: "Atlassian University",
      logo_path: "jira.png",
      alt_name: "Atlassian University",
      color_code: "#2AAFED",
    },
    {
      title: "How to Fix Bad Agile",
      subtitle: "Atlassian University",
      logo_path: "jira.png",
      alt_name: "Atlassian University",
      color_code: "#2AAFED",
    },
    {
      title: "Deep learning and Reinforcement learning",
      subtitle: "Deeplearning.io",
      logo_path: "deeplearning.png",
      alt_name: "Deeplearning.ai",
      color_code: "#fe0037",
    },
    {
      title: "Creating an agile culture",
      subtitle: "Atlassian University",
      logo_path: "jira.png",
      alt_name: "Atlassian University",
      color_code: "#2AAFED",
    },
    {
      title: "Applied Machine Learning: Feature Engineering",
      subtitle: "Applied Machine Learning and Feature Engineering",
      logo_path: "applied-machine-learning-img.jpg",
      alt_name: "Applied Machine Learning and Feature Engineering",
      // color_code: "#f36c3d",
      color_code: "#ffc475",
    },
    {
      title: "Essential Math for Machine Learning: Python Edition",
      subtitle: "Essential Math for Machine Learning: Python Edition",
      logo_path: "cap_aml.jpg",
      alt_name: "Essential Math for Machine Learning: Python Edition",
      // color_code: "#f36c3d",
      color_code: "#b190b0",
    },
    {
      title: "Computer version with deep learning",
      subtitle: "Computer version with deep learning",
      logo_path: "78694809.jpg",
      alt_name: "Computer version with deep learning",
      // color_code: "#f36c3d",
      color_code: "#ffbfae",
    },
    {
      title: "Full-stack  angular and spring Boot",
      subtitle: "Full-stack  angular and spring Boot",
      logo_path: "springboot.png",
      alt_name: "Full-stack  angular and spring Boot",
      // color_code: "#f36c3d",
      color_code: "#0C9D5899",
    },
    {
      title: "Full-stack  React and spring Boot",
      subtitle: "Full-stack  React and spring Boot",
      logo_path: "React-Spring.jpg",
      alt_name: "Full-stack  React and spring Boot",
      // color_code: "#f36c3d",
      color_code: "#0C9D5899",
    },
    {
      title: "Full-stack  React and Express",
      subtitle: "Full-stack  React and Express",
      logo_path: "MERN-Logo-4-pack.jpg",
      alt_name: "Full-stack  React and Express",
      // color_code: "#f36c3d",
      color_code: "#0C9D5899",
    },
    {
      title: "AI for medical Treatment",
      subtitle: "AI for medical Treatment",
      logo_path: "health.jpg",
      alt_name: "AI for medical Treatment",
      // color_code: "#f36c3d",
      color_code: "#b190b0",
    },
    {
      title: "AI for Medical Diagnosis",
      subtitle: "AI for Medical Diagnosis",
      logo_path: "cap_aml.jpg",
      alt_name: "AI for Medical Diagnosis",
      // color_code: "#f36c3d",
      color_code: "#b190b0",
    },
    {
      title: "AI for Medical Prognosis",
      subtitle: "AI for Medical Prognosis",
      logo_path: "brain.jpg",
      alt_name: "AI for Medical Prognosis",
      // color_code: "#f36c3d",
      color_code: "#b190b0",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Botswana Institute for Technology Research and Innovation",
          company: "Full Stack Developer",
          company_url: "http://www.bitri.co.bw/",
          logo_path: "bitri.png",
          duration: "Oct 2019 - Present",
          location: "",
          description: `
          Involved in Requirements gathering and application development using AGILE SCRUM methodology for large projects.
          Source control versioning using Bit Bucket.
           Improving slow API responses
          Adhering to test standards, developing testable code and conducting unit tests and behavioural testing.
           Making recommendations as to the feasibility of implementing new or existing technologies and/or frameworks.
          Developing frontend and backend software as a member of a fast-paced agile team.
          developing high performance, scalable, reliable systems 
          Developing front end Single Page (SPA’s) using various JavaScript frameworks such as Angular 7,  and Ionic. 
          Backend development and configuration using various Spring framework features such as Spring MVC, Spring AOP, Spring Boot, Spring ORM and Spring Security.
          Hands-on experience in working with continuous integration tools like Jenkins and deployment using Docker Containers.
          Deliver the project Blue Print ( requirements elicitation, requirements modelling, Requirements documentation.
          Ensure compliance to specifications, Quality Control and Quality Assurance in overall projects delivery.
          
          `,
          // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Debswana Diamond Company",
          company: "Intern",
          company_url: "http://www.debswana.com/",
          logo_path: "dimond.png",
          duration: "January 2019 - October 2019",
          location: "",
          description: `Provided end-user support services for desktop hardware for more than 1500 users and software running Microsoft family platforms.
            Provided computer help desk support and technical training on hardware and software to end-users in the green area for 500 people
             Managed  almost  50 end-users (customers) on daily queries and reports
             Configured and added printers to the network to enable sharing of the resource by the department.
             Configured, installed wireless access points and IP phones.
            Provided server management on hardware and software.
            Maintained technologies (including active directory, Groups policy, MS Exchange etc.) to ensure server security.
            `,
          color: "#4285F4",
        },
        {
          title: "Ngwana Enterprises",
          company: "Intern project manager",
          company_url: "https://www.facebook.com/NGWANAAFRICA/",
          logo_path: "africa.png",
          duration: "Feb 2021 - Present",
          location: "Work from Home",
          description: `Taught students and teachers coding under the Africa code week
          Taught robotics in junior schools using Legos
          Promoted the culture of STEM in both public and private schools in north-east
          Held entrepreneurship events under Global entrepreneurship
          week
          `,
          color: "#196acf",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create NodeJS Backend Projects,Spring boot backend Projects, Python Scripts(Django and Flask), and React,Angular Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "jones.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Curious to know more? Do you want to get my thoughts on your projects and ideas? , Please follow my blogs.",
    link: "https://twitter.com/jonesdd10",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Text Summaraizer",
      url: "https://github.com/jones345/text-summary-using-fuzzy-logic",
      description: "text-summary-using-fuzzy-logic",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "14",
      name: "face recognition with deep learning",
      url: "https://github.com/jones345/face-recognition-deep-learning",
      description:
        "Face Detection,Feature Extraction,Face Representation,Face Matching,Face Recognition",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "14",
      name: "resume Screening",
      url: "https://github.com/jones345/resume-Screening",
      description:
        " A resume screening  program capable of categorizing skills into six different concentration areas (e.g. quality/six sigma, operations management, supply chain) ",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "1",
      name: "react firebase-auth",
      url: "https://github.com/jones345/react-social--with-firebase",
      description:
        " React with the power of firebase Auth, Google Auth, Facebook Auth, and more. ",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "2",
      name: "spring boot security demo ",
      url: "https://github.com/jones345/spring-boot-security-demo",
      description: "Spring Boot Security Demo using JWT, BCrypt, and more. ",
      languages: [
        {
          name: "java",
          iconifyClass: "logos-java",
        },
        {
          name: "Spring Boot",
          iconifyClass: "logos-spring",
        },
      ],
    },
    {
      id: "3",
      name: "android-movie-app",
      url: "https://github.com/jones345/android-movie-app",
      description:
        "android movie app with online movies ,showing trending movies now playing",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "4",
      name: "data structures and algorithms",
      url: "https://github.com/jones345/javascript-data-structures-and-algorithms",
      description:
        `1. Array
        2. Queues
        3. Linked List
        4. Trees
        5. Graphs
        6. Hashtable / map
        `,
      languages: [
        {
          name: "Javascript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "4",
      name: "React Dashboard",
      url: "https://github.com/jones345/react-dashboard",
      description:
        `React dashboard with Tailwind 
        `,
      languages: [
        {
          name: "Javascript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "4",
      name: "Angular and Spring Boot",
      url: "https://github.com/jones345/angular-spring-boot",
      description:
        `angular user login,registrations, authority, roles, calendar, events booking, using spring boot as backend and more user roles
        `,
      languages: [
        {
          name: "Javascript",
          iconifyClass: "logos-angular",
        },
        {
          name: "React",
          iconifyClass: "logos-spring",
        },
      ],
    },
    {
      id: "1",
      name: "react social with firebase",
      url: "https://github.com/jones345/react-social--with-firebase",
      description:
        " React with the power of firebase Auth, Google Auth, Facebook Auth, and more. ",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Javascript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "1",
      name: "Mask-RCNN",
      url: "https://github.com/jones345/Mask-RCNN",
      description:
        " Mask-RCNN ",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "1",
      name: `angular firebase project `,
      url: "https://github.com/jones345/angular-firebase-project",
      description:
        `simple angular project using firebase cloud storage , the project has firebase auth, firebase storage, send email, change language`,
      languages: [
        {
          name: "Angular",
          iconifyClass: "logos-angular",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "1",
      name: `spring boot mongdb crud `,
      url: "https://github.com/jones345/spring-mongdb-crud",
      description:
        `simple mongodb crud with spring boot`,
      languages: [
        {
          name: "Mongodb",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Spring boot",
          iconifyClass: "logos-spring",
        },
      ],
    },
    {
      id: "1",
      name: `expree.js, Passport.js and cookies`,
      url: "https://github.com/jones345/expreejs-Auth-security-cookies-and-more",
      description:
        `API points for login and registration, using the passport.js, to simplify the process of having to recreate login`,
      languages: [
        {
          name: "Passport Js",
          iconifyClass: "logos-passport",
        },
        {
          name: "Express Js",
          iconifyClass: "logos-express",
        },
      ],
    },
    {
      id: "1",
      name: `Django news app with django rest framework`,
      url: "https://github.com/jones345/Django--crud-sport-app",
      description:
        `Django news app with django rest framework and more`,
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Django",
          iconifyClass: "logos-django",
        },
      ],
    },
    {
      id: "1",
      name: `disease-prediction`,
      url: "https://github.com/jones345/disease-prediction-",
      description:
        `Disease prediction using machine learning using tensorflow, DecisionTree, randomforest and NaiveBayes`,
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
        
      ],
    },
    {
      id: "1",
      name: `chatbot`,
      url: "https://github.com/jones345/chatbot",
      description:
        `chatbot using machine learning using tensorflow`,
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
        
      ],
    },
    
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
